module.exports = __webpack_public_path__ + "static/media/peps.ee037ab6.png";